var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1.70711","y1":"1.29289","x2":"16.7071","y2":"16.2929","stroke":"#BABFCB","strokeWidth":"2","key":0}),React.createElement("line",{"y1":"-1","x2":"21.2132","y2":"-1","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 17 2)","stroke":"#BABFCB","strokeWidth":"2","key":1})]);
}

Close.defaultProps = {"width":"18","height":"17","viewBox":"0 0 18 17","fill":"none"};

module.exports = Close;

Close.default = Close;
